var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangedismiss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Orange_close_mark",
    "data-name": "Orange close mark",
    transform: "translate(-431 -320)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(431 320)",
    fill: "#f60"
  }), /*#__PURE__*/React.createElement("g", {
    id: "close_1_",
    "data-name": "close (1)",
    transform: "translate(438.168 327.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "close_1_2",
    "data-name": "close (1)",
    d: "M5.717,4.967,9.48,1.2A.626.626,0,1,0,8.595.319L4.832,4.082,1.069.319A.626.626,0,0,0,.184,1.2L3.946,4.967.184,8.73a.626.626,0,1,0,.885.885L4.832,5.853,8.595,9.616A.626.626,0,0,0,9.48,8.73Zm0,0",
    transform: "translate(0 -0.136)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangedismiss);
export default __webpack_public_path__ + "static/media/orangedismiss.bc616e5005310a708a3f29d7f3aa4a3f.svg";
export { ForwardRef as ReactComponent };